import cn from "classnames";
import { t } from "i18next";
import moment from "moment";

import { OrderCallConfirmationResult } from "../../constants";
import { CallConfirmationBadgeProps } from "./CallConfirmationBadge.types";

import styles from "./CallConfirmationBadge.module.scss";

const RESULT_LABELS: Record<OrderCallConfirmationResult, string> = {
  [OrderCallConfirmationResult.Confirmed]: "Confirmed",
  [OrderCallConfirmationResult.Unreachable]: "Unreachable",
  [OrderCallConfirmationResult.Cancelled]: "Cancelled"
};

const RESULT_MODIFIERS: Record<OrderCallConfirmationResult, string> = {
  [OrderCallConfirmationResult.Confirmed]: styles.badge__green,
  [OrderCallConfirmationResult.Unreachable]: styles.badge__orange,
  [OrderCallConfirmationResult.Cancelled]: styles.badge__red
};

const CallConfirmationBadge = ({
  result,
  at,
  className
}: CallConfirmationBadgeProps) => {
  if (!result) {
    return (
      <span className={cn(styles.badge, styles.badge__neutral, className)}>
        {t("No status")}
      </span>
    );
  }

  return (
    <span
      className={cn(styles.badge, RESULT_MODIFIERS[result], className)}
      title={at ? moment(at).format("DD/MM/YYYY HH:mm") : undefined}
    >
      {t(RESULT_LABELS[result])}
    </span>
  );
};

export default CallConfirmationBadge;
